import { DEFAULT_SLICE_SECTION_NAME, SliceNameType } from '@/redux/slices/pdpSlice';
import { createContext, ReactNode, useContext } from 'react';

interface PDPSliceSelectorContextType {
  sliceName: SliceNameType;
}

const initialPDPSliceSelectorContextValue: PDPSliceSelectorContextType = {
  sliceName: DEFAULT_SLICE_SECTION_NAME
};

const PDPSliceSelectorContext = createContext<PDPSliceSelectorContextType>(
  initialPDPSliceSelectorContextValue
);

// eslint-disable-next-line react-refresh/only-export-components
export const usePDPSliceSelectorContext = () => {
  const context = useContext(PDPSliceSelectorContext);
  if (context === undefined) {
    throw new Error('usePDPSliceSelectorContext must be used within a PDPSliceSelector');
  }
  return context;
};

interface PDPSliceSelectorProviderProps {
  children: ReactNode;
  sliceName: SliceNameType;
}

export const PDPSliceSelectorProvider = ({
  children,
  sliceName
}: PDPSliceSelectorProviderProps) => {
  const value: PDPSliceSelectorContextType = {
    sliceName
  };

  return (
    <PDPSliceSelectorContext.Provider value={value}>{children}</PDPSliceSelectorContext.Provider>
  );
};
